// Vendors
import React from 'react';
// Components
import { IconHighlightedComponent, IconComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  LANDING_OPTIONS_LEFT_CONTENT_ICON_HIGHLIGHTED_PROPS,
  LANDING_OPTIONS_LEFT_CONTENT_ICON_PROPS,
} from './constants/landing-options-left-content.constants';
// Types
import { LandingOptionsLeftContentComponentType } from './types/landing-options-left-content.component.type';

const LandingOptionsLeftContentComponent = <T,>({
  icon,
}: LandingOptionsLeftContentComponentType<T>): React.JSX.Element => (
  <IconHighlightedComponent
    {...{ ...LANDING_OPTIONS_LEFT_CONTENT_ICON_HIGHLIGHTED_PROPS }}
    icon={<IconComponent {...{ ...LANDING_OPTIONS_LEFT_CONTENT_ICON_PROPS, icon }} />}
  />
);

export { LandingOptionsLeftContentComponent };
